export default __webpack_public_path__ + "static/tile_desktop@2x-ae2189515c62fd1def75e7f4d37e5e75.png";